import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { AccessRestriction, hasPermission } from 'utils/auth';
import { selectUserPermissions } from 'store/profile';

interface AccessControllerProps extends AccessRestriction {
  /**
   * The content to show, when the user does not have the correct permissions.
   */
  noAccessChildren?: ReactNode;
}

export const AccessController: FC<PropsWithChildren<AccessControllerProps>> = ({
  scope,
  mode,
  children,
  noAccessChildren,
}) => {
  const permissions = useSelector(selectUserPermissions);

  if (!hasPermission(permissions, { scope, mode })) {
    return <>{noAccessChildren || null}</>;
  }

  return <>{children}</>;
};
